import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgTimeBreakIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12 3a9 9 0 0 0 0 18c3 0 9-1.8 9-9M11 14V9M11 14h4"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M16 3h5l-5 5h5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTimeBreakIcon);
const Memo = memo(ForwardRef);
export default Memo;
